/**
 * from legacy theme.js.liquid
 * to main-cart-items.liquid
 */
class RewardsInput extends HTMLElement {

    maxi_VALID_PREFIXES = ['8110001','8110002','8110003','8110004','8110005','8110006','8110007','8110008',
                             
    '8220001','8220002','8220003','8220004','8220005','8220006',
    '8330001','8330002',
    '8330003','8330004','8330005','8330006','8330007','8330008'
   ];

   get rrCard() {
       this.getAttribute('rrCard');
   }
   set rrCard(value) {
       this.setAttribute(value);
   }

   static get observedAttributes() {
        return ['rrCard'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'rrCard' && this.shadowRoot) {

        }
    }
   connectedCallback() {
    this.hiddenInput = window.renderInputOutsideShadowRoot(this,
        'attributes[Robinsons Rewards]',this.agent)
    this.renderContents(false);

    }
   renderContents(parsedState) {       

    let templateContent = this.buildTemplate('');
    const shadowRoot = this.attachShadow({ mode: "open" });
    shadowRoot.appendChild(templateContent);
    this.attachEventHandlers();
       
    }

    attachEventHandlers() {
        const maxi_rr = this.shadowRoot.getElementById('robinsons-rewards');
        maxi_rr.addEventListener('input',this.handleInputChange.bind(this)); // maxi_rr.on('keyup',checkField);
    }

    handleInputChange(e) {

        this.hiddenInput.value = e.target.value

        const maxi_checknum = this.shadowRoot.querySelector('.maxi-checknum');
        const maxi_invalid = this.shadowRoot.querySelector('.maxi-invalid');
        const maxi_checkout = document.getElementById("checkout");

        this.checkField(e.target.value,maxi_checknum, maxi_invalid, maxi_checkout);
    }

    checkField(val, maxi_checknum, maxi_invalid, maxi_checkout) {
        
        var length = val ? val.length : 0;

        maxi_checknum.textContent = length + '/16';
        if (length == 0) {
          maxi_invalid.textContent = '';
          maxi_checkout.removeAttribute('disabled');      
        } else if ( length != 16 || ( Number.isNaN(val) 
             || !this.maxi_VALID_PREFIXES.includes(val.substring(0,7)) )  ) {
            maxi_invalid.textContent = 'Incorrect card number';    
          maxi_checkout.setAttribute('disabled','');
        } else {
          maxi_invalid.textContent = '';
          maxi_checkout.removeAttribute('disabled');
        }
    }


    buildTemplate(rrCard) {
        const template = document.createElement('template');
        template.innerHTML = `<p class="cart-attribute__field">
            <label for="robinsons-rewards" class="cart-attribute-custom" >Enter your 16-digit Robinsons Rewards or Go Rewards No. to earn points from this transaction</label>
            <input id="robinsons-rewards" class="cart-attribute-custom"  type="text" value="${rrCard}" />
                <span class="maxi-checknum">16/16</span>&nbsp;&nbsp;&nbsp;<span class="maxi-invalid" style="color: red"></span>
                <br/>
            </p>`;
        return template.content;
    }
}
customElements.define('maxi-rewards-input', RewardsInput);

  



  
  
  
  

  

  

  

